export default __webpack_public_path__ + "static/media/vietnamese.cd7285b9.svg";